export default __webpack_public_path__ + "static/icon-6-3-c1dadffa3d7bb6df802187cf8af42704.png";